var TEMPLATE_URL = require('./ike.toolbar.html');
angular.module('ikeweb.layout').directive('ikeToolbar',
    function() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: TEMPLATE_URL
        };
    }
);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/layout/toolbar/ike.toolbar.directive.js
// module id = 464
// module chunks = 0